import * as _ from "lodash";

export const arrangewagermatrix_removedup_dashes = (matrix: any) => {
  let return_ =  [{}];
  let counter = 0;

  _.forEach(matrix, (matrixData) => {
    let temp = [];
    if(matrixData.dashes){return true;}
    for (let i = 0; i < matrixData.data.length; i++) {
      if(temp.indexOf(matrixData.data[i][1]) === -1 && matrixData.data[i][1] ){
          temp.push(matrixData.data[i][1]);
      }
    }

    if(temp.length >= 1 && temp[0] != null){
      return_[counter] = matrixData;
      counter++;
    }

    return;
  });
  return return_;
}
